"use client";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { FontLineHeightMd, MarketingTypeFontCaptionWeight, MarketingTypeFontCaptionSize, MarketingTypeFontBodyCopyWeight, MarketingTypeFontBodyCopySize, MarketingTypeFontHeadingXsLineHeight, MarketingTypeFontHeadingXsWeight, MarketingTypeFontHeadingXsSize, MarketingTypeFontHeadingMdSize, FontLineHeightSm, FontWeightBold, MarketingTypeFontSubheadingXsLineHeight, MarketingTypeFontSubheadingXsWeight, MarketingTypeFontSubheadingXsSize, MarketingTypeFontSubheadingMdSize, FontSize6, MarketingTypeFontTitleXlSize, MarketingTypeFontTitleXsLineHeight, MarketingTypeFontTitleXsWeight, MarketingTypeFontTitleXsSize, MarketingTypeFontTitleMdSize, FontWeightDefault, BpMd } from "@nxt-costco-com/forge-design-tokens";
const marketingTypographyBodycopy = {
  fontSize: "1rem"
};
const marketingTypographyBodycopyV2 = {
  fontSize: MarketingTypeFontBodyCopySize,
  fontWeight: MarketingTypeFontBodyCopyWeight,
  lineHeight: FontLineHeightMd
  //This needs to be updated once the token is fixed
};
const marketingTypographyCaption = {
  fontSize: ".75rem"
};
const marketingTypographyCaptionV2 = {
  fontSize: MarketingTypeFontCaptionSize,
  fontWeight: MarketingTypeFontCaptionWeight,
  lineHeight: FontLineHeightMd
  //This needs to be updated once the token is fixed
};
const marketingTypographySubheading = {
  [`@media (min-width:${BpMd})`]: {
    fontSize: FontSize6
  },
  fontSize: "1.125rem",
  fontWeight: FontWeightBold
};
const marketingTypographySubheadingV2 = {
  [`@media (min-width:${BpMd})`]: {
    fontSize: MarketingTypeFontSubheadingMdSize
  },
  fontSize: MarketingTypeFontSubheadingXsSize,
  fontWeight: MarketingTypeFontSubheadingXsWeight,
  lineHeight: MarketingTypeFontSubheadingXsLineHeight
};
const marketingTypographyTitleWithOutXl = {
  [`@media (min-width:${BpMd})`]: {
    fontSize: "2.625rem"
  },
  fontSize: "1.625rem",
  fontWeight: FontWeightBold,
  lineHeight: FontLineHeightSm
};
const marketingTypographyTitleWithOutXlV2 = {
  [`@media (min-width:${BpMd})`]: {
    fontSize: MarketingTypeFontTitleMdSize
  },
  fontSize: MarketingTypeFontTitleXsSize,
  fontWeight: MarketingTypeFontTitleXsWeight,
  lineHeight: MarketingTypeFontTitleXsLineHeight
};
const marketingTypographyTitleWithXl = {
  ...marketingTypographyTitleWithOutXl,
  "@media (min-width:1400px)": {
    fontSize: "3.5rem"
  }
};
const marketingTypographyTitleWithXlV2 = {
  ...marketingTypographyTitleWithOutXlV2,
  "@media (min-width:1400px)": {
    fontSize: MarketingTypeFontTitleXlSize
  }
};
const marketingTypographyHeading = {
  [`@media (min-width:${BpMd})`]: {
    fontSize: "1.625rem"
  },
  fontSize: "1.25rem",
  fontWeight: FontWeightBold,
  lineHeight: FontLineHeightSm
};
const marketingTypographyHeadingV2 = {
  [`@media (min-width:${BpMd})`]: {
    fontSize: MarketingTypeFontHeadingMdSize
  },
  fontSize: MarketingTypeFontHeadingXsSize,
  fontWeight: MarketingTypeFontHeadingXsWeight,
  lineHeight: MarketingTypeFontHeadingXsLineHeight
};
const marketingTypographyBodycopySmV2 = {
  fontSize: "0.875rem",
  lineHeight: "1.5"
};
const variantStyles = {
  title: marketingTypographyTitleWithOutXl,
  title_v2: marketingTypographyTitleWithOutXlV2,
  title_with_xl: marketingTypographyTitleWithXl,
  title_with_xl_v2: marketingTypographyTitleWithXlV2,
  subheading: marketingTypographySubheading,
  subheading_v2: marketingTypographySubheadingV2,
  heading: marketingTypographyHeading,
  heading_v2: marketingTypographyHeadingV2,
  bodycopy: marketingTypographyBodycopy,
  bodycopy_v2: marketingTypographyBodycopyV2,
  body_copy_sm_v2: marketingTypographyBodycopySmV2,
  caption: marketingTypographyCaption,
  caption_v2: marketingTypographyCaptionV2
};
const CustomMarketingTypography = styled(Text, {
  shouldForwardProp: (prop) => !["isMarkdown", "variant", "sx"].includes(prop)
})(({ variant }) => ({
  fontWeight: FontWeightDefault,
  ...variantStyles[variant]
}));
export {
  CustomMarketingTypography,
  marketingTypographyBodycopy,
  marketingTypographyBodycopySmV2,
  marketingTypographyBodycopyV2,
  marketingTypographyCaption,
  marketingTypographyCaptionV2,
  marketingTypographyHeading,
  marketingTypographyHeadingV2,
  marketingTypographySubheading,
  marketingTypographySubheadingV2,
  marketingTypographyTitleWithOutXl,
  marketingTypographyTitleWithOutXlV2,
  marketingTypographyTitleWithXl,
  marketingTypographyTitleWithXlV2
};
